import { createTheme } from '@mui/material/styles'
import {COLORS} from './config/constants';

const MUI_THEME = createTheme({
  typography: {
    fontFamily: 'Roboto',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
            color: COLORS.GRAY_BORDER_LIGHT,
            background: 'transparent',
            border: `1px solid ${COLORS.WHITE_BORDER}`,
            '> textarea': {
              padding: 0
            },
            '&.Mui-error': {
              border: `1px solid ${COLORS.RED_DARK}`,
            },
            '&.Mui-focused': {
              border: `2px solid ${COLORS.PRIMARY}`,
            }
          },
          '& .MuiInputLabel-root': {
            fontWeight: 400,
            color: COLORS.WHITE_SECONDARY,
            background: COLORS.BLACK,
            padding: '0 4px',
            fontFamily: 'Roboto, sans-serif',
            '&.Mui-error': {
              color: COLORS.WHITE_SECONDARY,
            }
          },
          '& .MuiOutlinedInput-input': {
            color: COLORS.WHITE,
            fontFamily: 'Roboto, sans-serif',
            backgroundColor: 'transparent',
          },
          '& .MuiInputAdornment-root': {
            marginRight: '-4px',
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '0 8px 0 2px',
          'svg': {
            fill: COLORS.PRIMARY,
            'path': {
              d: "path('M19 5V19H5V5H19ZM21 3H3V21H21V3Z')",
            }
          },
          '&.Mui-checked svg, &.Mui-checked path': {
            color: COLORS.PRIMARY,
          },
          '&.Mui-checked svg path': {
            d: "path('M21.6807 3H3.68066V21H21.6807V3ZM10.6807 17L5.68066 12L7.09066 10.59L10.6807 14.17L18.2707 6.58L19.6807 8L10.6807 17Z')",
          },
          '&.Mui-disabled svg, &.Mui-disabled path': {
            color: COLORS.GRAY_BORDER,
          },
        },
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        label: {
          lineHeight: 1.44,
          marginLeft: 0,
          fontFamily: 'Roboto, sans-serif',
          fontSize: 14,
          color: COLORS.WHITE,
          letterSpacing: 0,
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '100%',
          '& .MuiFormLabel-root': {
            borderRadius: 0,
            color: COLORS.BLACK,
            fontWeight: 500,
          },
          '& .MuiInputLabel-root': {
            fontWeight: 400,
            color: COLORS.GRAY_LIGHT_SECONDARY,
            letterSpacing: '0.15px',
            overflow: 'visible',
            '&.Mui-error': {
              color: COLORS.GRAY_LIGHT_SECONDARY,
            },
            '&.Mui-disabled': {
              color: COLORS.GRAY_DISABLED,
            }
          },
          '& .MuiOutlinedInput-input': {
            color: COLORS.BLACK,
            padding: '16.5px 13px',
            '@media (max-width: 767px)': {
              padding: '8.5px 10px',
            },
            '&.Mui-disabled': {
              color: COLORS.GRAY_DISABLED,
            }
          },
          '& .MuiInputBase-root': {
            borderRadius: 0,
            backgroundColor: COLORS.WHITE,
            ':not(.MuiInputBase-multiline)': {
              height: '56px',
              '@media (max-width: 767px)': {
                height: '40px',
              },
            },
            '&.MuiOutlinedInput-root': {
              '&.Mui-focused': {
                '.MuiOutlinedInput-notchedOutline': {
                  border: '1px solid transparent',
                }
              },
              '&.Mui-error': {
                '.MuiOutlinedInput-notchedOutline': {
                  border: '1px solid transparent',
                }
              }
            }
          },
          '.MuiInputBase-root svg': {
            right: '12px',
          },
          '.MuiFormHelperText-root': {
            fontFamily: 'Roboto, sans-serif',
            position: 'absolute',
            bottom: '-24px',
            '@media (max-width: 767px)': {
              fontSize: '10px',
              bottom: '-16px',
            },
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: COLORS.WHITE_SECONDARY,
          '&:not(.Mui-focused):not(.MuiFormLabel-filled):not(.MuiInputLabel-shrink)': {
            '@media (max-width: 767px)': {
              lineHeight: 1,
              fontSize: '12px',
              padding: '8px 4px',
              transform: 'translate(7px, 12px) scale(1)',
            },
          },
        }
      }
      },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.BLACK_BACKDROP,
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          fontFamily: 'Roboto, sans-serif',
          borderRadius: 0,
          textAlign: 'left',
          padding: '10px 16px',
          '.MuiAlert-icon': {
            marginRight: '16px',
          },
          '.MuiAlert-action .MuiIconButton-root svg, .MuiAlert-action .MuiSvgIcon-root': {
            color: COLORS.WHITE,
            fill: 'currentColor',
          },
          '.MuiIconButton-root': {
            padding: '4px 12px',
          },
          '&.MuiAlert-standardError': {
            background: COLORS.RED_LIGHT,
            color: COLORS.WHITE,
            'svg': {
              fill: COLORS.WHITE,
            },
          },
          '&.MuiAlert-standardWarning': {
            background: COLORS.WARNING_LIGHT,
            color: COLORS.WHITE,
            'svg': {
              fill: COLORS.WHITE,
            },
          },
          '&.MuiAlert-standardInfo': {
            background: COLORS.PRIMARY_INFO,
            color: COLORS.WHITE,
            'svg': {
              fill: COLORS.WHITE,
            },
          },
          '& .MuiAlert-message': {
            width: '100%'
          },
          '& .MuiAlertTitle-root': {
            fontFamily: 'Roboto, sans-serif',
            fontSize: '16px',
            letterSpacing: '0.25px',
            paddingLeft: '4px',
            '@media (max-width: 767px)': {
              fontSize: '14px',
            },
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Roboto, sans-serif',
          fontSize: '13px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 1.7,
          letterSpacing: '0.46px',
          textTransform: 'uppercase',
          color: COLORS.WHITE,
          borderRadius: 0,
          padding: '4px',
          'img': {
            marginRight: '8px',
          },
          '&.MuiButton-outlined': {
            border: `1px solid ${COLORS.WHITE}`,
          },
          '&.MuiButton-contained': {
            padding: '9px 12px 9px 16px',
            display: 'flex',
            justifyContent: 'center',
            letterSpacing: '1.2px',
            boxShadow: 'none',
            '@media (max-width: 767px)': {
              padding: '6px 8px 6px 6px',
              fontSize: '14px',
              letterSpacing: '-0.3px',
              justifyContent: 'center',
              'svg': {
                marginRight: '8px',
                width: '20px',
                height: '20px',
              },
            },
          },
          '&.Mui-disabled': {
            backgroundColor: COLORS.GRAY_DARK,
            color: COLORS.GRAY_TEXT,
          }
        }
      }
    },
  },
  palette: {
    primary: { main: COLORS.PRIMARY },
    secondary: { main: COLORS.PRIMARY },
    info: { main: COLORS.WHITE },
    error: { main: COLORS.RED_DARK },
  },
})

export default MUI_THEME
